import { StorageLRU, asyncify } from 'storage-lru';
import routes from 'App/routeConstants';
import _ from 'lodash';
const storageLRU = new StorageLRU(asyncify(localStorage));

export function makeACopy(props) {
  const {allDesktopElements, allMobileElements, returnRedirectUrl} = props;
  const created = new Date().getTime();
  const id = 'tpl_copy_' + created.toString(16);
  const cacheControl = 'max-age=3600,stale-while-revalidate=86400';
  let redirectUrl = `${routes.Editor.TemplateURL}?template_copy_id=${id}`;
  if (props.itemId) {
    redirectUrl += `&itemId=${props.itemId}`;
  }
  _.forEach(_.pick(props.location.query, ['view', 'backTo']), (value, key) => {
    redirectUrl += `&${key}=${value}`;
  });
  storageLRU.setItem(id, {
    desktop: allDesktopElements,
    mobile: allMobileElements
  }, {
    json: true,
    cacheControl: cacheControl
  });
  if (returnRedirectUrl) {
    require('shared/helpers/TemplateService').templateService.immediatePreventConfirmNavigation();
    return redirectUrl;
  }
  window.open(redirectUrl);
}
